module.exports = __webpack_public_path__ + "static/media/Roboto-300.c73eb1ce.woff";